/**
 * Parse a Contentful Date field into a local-midnight Date.
 *
 * Contentful may return a date-only string ("2025-04-03") or a full
 * ISO datetime ("2025-04-03T00:00:00.000Z").  A bare date-only string
 * is parsed as UTC by the Date constructor, which shifts the displayed
 * day for users west of UTC.  This helper always produces a Date whose
 * local year/month/day matches the original value.
 */
export function parseLocalDate(value: string): Date {
  const dateOnly = value.includes("T") ? value.split("T")[0] : value;
  return new Date(`${dateOnly}T00:00:00`);
}
